exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field .field-label[data-v-50505f88] {\n  min-width: 9rem;\n}", ""]);

// exports
